export default __webpack_public_path__ + "static/media/pocket.23f34d83.webp";